<template>
  <div>
    <oil-form v-if='loading'
              :title='tableTitle'
              :keys='tableKeys'
              :items='contract'
              :createForm='!id || !contract.Id'
              :formCallback='formCallBack'
    >
      <template v-slot:TotalPrice='{rules,input}'>
        <v-text-field
            :disabled='!input.isEdit'
            label='Общая стоимость'
            :rules='[...rules]'
            v-model='tempPrice'
            outlined
            dense

        >

        </v-text-field>

      </template>
      <template v-slot:header='{id}'>
        <v-tooltip bottom>
          <template v-slot:activator='{ on, attrs }'>
            <v-btn class='mx-8' type='button' icon
                   @click='$router.push({path:`/additional-contract-create/${contract.Id || id}`})'
                   v-bind='attrs'
                   v-on='on'
            >
              <v-icon>
                mdi-content-paste
              </v-icon>
            </v-btn>
          </template>
          <span>ДОБАВИТЬ ПРИЛОЖЕНИЕ</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator='{ on, attrs }'>
            <v-btn v-if='id' class='mr-8' type='button' icon
                   @click="showMePdf('contract/print',id)"
                   v-bind='attrs'
                   v-on='on'
            >
              <v-icon>
                mdi-pdf-box
              </v-icon>
            </v-btn>
          </template>
          <span>СКАЧАТЬ И ПЕЧАТЬ</span>
        </v-tooltip>
      </template>
      <template v-slot:Buyer.Id='{rules,input}'>
        <v-autocomplete
            :items='result$'
            v-stream:keyup.native='search$'
            :disabled='!input.isEdit'
            hide-no-data
            @change='changeBuyer'
            class='z-index'
            clearable
            :rules='[...rules]'
            dense
            outlined
            hide-selected
            :value='contract.Buyer.CompanyName'
            item-text='CompanyName'
            label='Выбрать покупателя'
            return-object
        ></v-autocomplete>
      </template>


      <template v-slot:Registry='{input}' v-if='id'>
        <v-btn :disabled='!input.isEdit' style='background-color: darkslategray;color: #f7f7f7' outlined class='my-5'
               @click='appendChild'>
          ФАЙЛЫ +
        </v-btn>
        <FileAdd
            :con='contract'
            :input='input'
            :item='contract'
        />
      </template>


    </oil-form>

    <div v-if='loading && contractAppendixes.length > 0'>
      <h2 class='mt-10 mb-10'>Доп. предложении</h2>
      <TEST
          class='mt-5'
          :items='contractAppendixes'
          :headers='contractAppendixKeys'
          @clickUpdate='showAppendix'
          @clickPdf='showAppendixPdf'
          @clickDelete='deleteAppendix'
      />

    </div>
    <div v-if='loading && wayBills.length > 0'>
      <h2 class='mt-10 mb-10'>Договора</h2>
      <TEST
          class='mt-5'
          :items='wayBills'
          :headers='contractWaybills'
          @clickUpdate='showAppendix'
          @clickPdf='showAppendixPdf'
          @clickDelete='deleteAppendix'
      />
    </div>


  </div>


</template>

<script>
import { companiesService } from '@/services/CompaniesService'
import { contractsService } from '@/services/ContractsService'
import { formKeys, formTitle } from './setting/ContractHelper.js'
import { num2str } from '@/utils/functions/MoneyFromString'
import { waybillService } from '@/services/WayBillService'
import { debounceTime, distinctUntilChanged, filter, pluck, switchMap } from 'rxjs/operators'
import { coreApi } from '@/services/core'
import FileAdd from '~/pages/contract/setting/FileAdd'
import { additionalContractService } from '~/services/AdditionalContractService'

export default {
  props: {
    id: String
  },
  components: {
    FileAdd,
    OilForm: () => import('@/components/helper/oil.form.vue'),
    OilDataTable: () => import('@/components/helper/oil.table'),
    OilDatePicker: () => import('@/components/helper/form/oil.date.picker'),
    OilModal: () => import('@/components/helper/form/oil.delete.modal'),
    TEST: () => import('@/components/helper/table/MinTable')

  },
  domStreams: ['search$'],
  subscriptions() {
    return {
      result$: this.search$.pipe(
          pluck('event', 'target', 'value'),
          debounceTime(200),
          filter(value => value.length > 2),
          debounceTime(100),
          distinctUntilChanged(),
          switchMap(query => coreApi.get(`company/search/name?pattern=${query}`)),
          pluck('data')
      )
    }
  },
  data: () => ({
    tableKeys: formKeys,
    keys: [
      '#', 'Названия', 'Комментарии', 'Дата', 'ФАЙЛ', 'Скачать', 'Удалить'
    ],
    contractAppendixKeys: [
      { text: 'НОМЕР', value: 'Number' },
      { text: 'ДАТА', value: 'SignedDate' },
      { text: 'ОстатОк(тн)', value: 'RemainingVolume' }
    ],
    contractWaybills: [
      { text: 'НОМЕР', value: 'Number' },
      { text: 'ДАТА', value: 'ShipmentDate' },
      { text: 'СТАТУС', value: 'Status' }
    ],
    dateKeys: {
      attrs: {
        class: 'mt-6',
        readonly: false,
        outlined: true,
        dense: true,
        label: 'Дата'
      }
    },
    contract: {
      AdditionalFiles: [],
      Buyer: {
        Id: ''
      },
      SignedDate: '',
      StartDate: '',
      EndDate: '',
      Number: '',
      Status: '',
      Type: 'sell',
      PaymentTerms: '',
      TotalPrice: '',
      TotalPriceInText: '',
      Seller: {}
    },
    tableTitle: '',
    tempPrice: "",
    wayBills: [],
    empows: [],
    loading: false
  }),
  async created() {
    this.tableKeys['Buyer.Id'].attrs.readonly = false
    this.tableTitle = formTitle(!this.id)
    const response = await companiesService.getAll()
    this.tableKeys['Buyer.Id'].attrs.items = response.data
    this.result$ = response.data
    if (this.id) {
      const contract = await contractsService.getById(this.id)
      this.contract = contract.data
      this.tempPrice = this.contract?.TotalPrice
      const ttn = await waybillService.getContractById(this.contract.Buyer.Id)
      this.wayBills = ttn.data

      const empows = await contractsService.getEmpowById(this.contract.Buyer.Id)
      this.empows = empows.data


    }
    if (this.companyId) {
      const buyer = await companiesService.getById(this.companyId)
      this.contract.Buyer = buyer.data
      this.tableKeys['Buyer.Id'].attrs.readonly = true
    }
    this.contract.AdditionalFiles ??= []
    this.loading = true
  },
  computed: {
    storeType() {
      if (this.id) {
        return contractsService.update
      }
      return contractsService.create
    },
    companyId() {
      return this.$route.query.companyId
    },
    message() {
      return this.id ? 'договор удачно изменен' : 'договор удачно создан'
    },
    contractAppendixes() {
      const appendix = this.contract?.Appendixes
      if (appendix) {
        return appendix.map(app => {
          const RemainingVolume =
              parseFloat(app.RemainingVolume).toFixed(4)
          return {
            ...app,
            RemainingVolume: RemainingVolume
          }
        })
      }
      return this.contract?.Appendixes || []

    }
  },
  methods: {
    async api(query) {
      return coreApi.get(`company/search/name?pattern=${query}`)
    },
    showAppendix(id) {
      this.$router.push({ path: `/additional-contract-show/${id}` })
    },
    showAppendixPdf(id) {
      this.showMePdf('contract/appendix/print', id)
    },
    changeBuyer(buyer) {
      if (!buyer) return
      this.contract.Buyer = buyer
    },
    appendChild() {
      this.contract.AdditionalFiles.push({
        Name: '',
        Comment: '',
        StartDate: ''
      })
    },
    async deleteAppendix(id) {
      const response = await additionalContractService.delete(id)
      const isDelete = response.data
      if (isDelete) {
        const appendixes = this.contract?.Appendixes
        const appendix = appendixes?.find(({ Id }) => Id === id)
        const index = appendixes?.indexOf(appendix)
        appendixes?.splice(index, 1)
        this.$notify({
          group: 'mgs',
          type: 'success',
          title: `Дополнительное приложение под номер ${appendix.Number} удачно удален`
        })
      }
    },
    async formCallBack(data, input, form, func) {
      input.isEdit = false
      const response = await this.storeType(data)
      if (!response.data) {
        input.isEdit = true
        return
      }
      const id = response.data?.Id
      this.contract.Id = id
      this.contract = response.data
      // this.tableTitle = formTitle(false)
      await this.$router.push('/contracts')
      func(this.message)
    },
    openPdf(id, path) {
      window.open(process.env.VUE_APP_BACKEND_API + `/${path}/${id}`)
    }
  },

  watch: {
    'tempPrice'(price) {
      this.contract.TotalPriceInText = num2str(price)
      this.tempPrice = price.toString().replaceAll(' ', '').replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
      this.contract.TotalPrice = this.tempPrice.toString().replaceAll(' ', '')
    },
    'contract.Number'(id) {
    }
  }

}
</script>